<template>
	<div class="w-full bg-[#050508]/80 backdrop-blur-2xl border-b border-white/10 nav fixed top-0 left-0 right-0 z-[100] transition-all duration-300" id="nav">
		<div class="container mx-auto px-6 py-7 md:px-24 lg:px-36 z-10">
			<!-- ------------------------- For Desktop  ------------------------- -->
			<div class="xl:flex flex-row justify-between hidden">
				<div class="flex flex-row items-center">
					<!-- style="
								-webkit-filter: drop-shadow(0.5px 0.5px 0 gray)
									drop-shadow(-0.5px 0.5px 0 gray)
									drop-shadow(0.5px -0.5px 0 gray)
									drop-shadow(-0.5px -0.5px 0 white);

								filter: drop-shadow(0.5px 0.5px 0 gray)
									drop-shadow(-0.5px 0.5px 0 gray)
									drop-shadow(0.5px -0.5px 0 gray)
									drop-shadow(-0.5px -0.5px 0 gray);" -->
					<router-link to="/legacy">
						<div
							class="flex flex-row gap-4 items-center justify-start"
						>
							<img
								class="w-12"
								src="/promo/logo-yellow-icon.png"
							/>
							<img
								class="w-44"
								style="filter: brightness(0) invert(1)"
								src="/promo/logo-dark.png"
							/>
							<!-- <div
								class="text-4xl font-bold italic uppercase text-slate-600"
							>
								Paydeck
							</div> -->
						</div>
					</router-link>
				</div>
				<div class="flex flex-row items-center hide-nav">
					<template v-for="(menu_item, i) in menu_links">
						<a
							:key="'menu_' + i"
							:href="menu_item.link"
							v-if="menu_item.link != '/legacy'"
						>
							<div
								class="px-6 py-2 mt-2 md:mt-3 rounded-full transition-all duration-300"
								:class="{
									'bg-blue-600 hover:bg-blue-500 text-white shadow-[0_0_20px_rgba(37,99,235,0.3)] hover:shadow-[0_0_30px_rgba(37,99,235,0.5)]': menu_item.decorate,
									'hover:bg-white/5': !menu_item.decorate
								}"
							>
								<div
									class="font-bold"
									:class="{
										'text-white': menu_item.decorate,
										'text-slate-300 hover:text-white': !menu_item.decorate && menu_item.value != '|',
										'text-white/20': menu_item.value == '|'
									}"
								>
									{{ menu_item.value }}
								</div>
							</div>
						</a>
					</template>
				</div>
				<!-- <div class="flex flex-row items-center">
					<div class="mx-4 cursor-pointer f-18 nav-link font-normal">
						How this works?
					</div>
					<div class="mx-4 cursor-pointer f-18 nav-link font-normal">
						Payment Types
					</div>
				</div>
				<div class="flex flex-row items-center f-18 font-normal">
					<button class="mx-4 focus:outline-none nav-link">
						Log In
					</button>
					<button
						class="registration-button f-15 tracking-wider text-white focus:outline-none "
					>
						Register
					</button>
				</div> -->
			</div>
			<!-- ------------------------- For Mobile & Ipad View ------------------------- -->
			<div class="xl:hidden hide-nav">
				<div class="flex">
					<div @click="showMenu = !showMenu">
						<img
							class="h-8 menu-icon cursor-pointer"
							style="filter: invert(100%)"
							src="@/assets/image/menu.svg"
						/>
					</div>
					<div class="my-auto pl-6">
						<router-link to="/legacy"
							><div
								class="flex flex-row gap-2 items-center justify-start"
							>
								<img
									class="w-8"
									src="/promo/logo-yellow-icon.png"
								/>
								<!-- <img
									class="w-36"
									style="filter: brightness(0) invert(1)"
									src="/promo/logo-dark.png"
								/> -->
								<!-- <div
									class="text-2xl font-bold italic uppercase text-slate-600"
								>
									Paydeck
								</div> -->
							</div>
						</router-link>
					</div>
				</div>
				<transition
					enter-active-class="transition ease-in duration-700"
					enter-class="transform opacity-0 scale-95"
					enter-to-class="transform opacity-100 scale-100"
					leave-active-class="transition ease-in duration-75"
					leave-class="transform opacity-100 scale-100"
					leave-to-class="transform opacity-0 scale-95"
				>
					<div
						v-if="showMenu"
						class="origin-top-right fixed left-0 top-0 w-full"
					>
						<div class="bg-[#050508]/95 backdrop-blur-3xl h-screen p-6 md:p-12">
							<div
								class="w-full flex flex-row justify-between p-4"
								@click="showMenu = false"
							>
								<div
									class="text-4xl md:text-7xl text-white text-opacity-30 font-bold"
								>
									Menu
								</div>
								<img
									class="h-8 menu-icon cursor-pointer"
									style="filter: invert(100%)"
									src="@/assets/image/close.svg"
								/>
							</div>
							<div>
								<a
									v-for="(menu_item, i) in menu_links"
									:key="'menu_' + i"
									:href="menu_item.link"
								>
									<div
										class="px-6 py-4 mt-2 md:mt-3 bg-opacity-25 roundedx-xl"
										v-if="menu_item.value != '|'"
									>
										<div
											class="text-2xl md:text-4xl"
											:class="{
												'font-extrabold text-blue-400':
													menu_item.decorate,
												'font-bold text-white':
													!menu_item.decorate
											}"
										>
											{{ menu_item.value }}
										</div>
									</div>
								</a>
							</div>
							<div
								class="bg-gray-600 bg-opacity-25 my-6"
								style="height: 1px"
							></div>
							<div
								class="text-center f-15 font-bold text-gray-700"
							>
								© Paydeck Technologies Pvt Ltd 2020
								<br />All Rights Reserved <br /><br />Call
								Support: 0120-6856244<br />(10 Am - 6 Pm -
								Mon-Fri)
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showMenu: false,
			menu_links: [
				{
					link: "/legacy",
					value: "Home",
					decorate: false
				},
				{
					link: "/legacy/page/how-it-works",
					value: "How Paydeck Works?",
					decorate: false
				},
				// {
				// 	link: "/page/payment-types",
				// 	value: "Payment Types",
				// 	decorate: false
				// },
				{
					link: "#",
					value: "|",
					decorate: false
				},
				{
					link: "https://app.paydeck.in/user/login/new",
					value: "Register",
					decorate: false
				},
				{
					link: "https://app.paydeck.in/user/login",
					value: "Login",
					decorate: true
				}
			]
		};
	},
	mounted() {
		let myNav = document.getElementById("nav");
		window.onscroll = function () {
			"use strict";
			if (document.body.scrollTop >= 280) {
				myNav.classList.add("scroll");
			} else {
				myNav.classList.remove("scroll");
			}
		};
	}
};
</script>

<style scoped>
.navbar-background {
	background: linear-gradient(
		rgba(255, 255, 255, 0.1),
		rgba(255, 255, 255, 0)
	);
	/* border-bottom: 1px solid rgba(255, 255, 255, 0.3); */
}
.registration-button {
	/* position: absolute; */
	width: 130px;
	height: 45px;
	background: rgba(57, 19, 184, 0.74);
	border-radius: 5px;
	transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.registration-button:hover {
	transform: translateY(-5px);
	box-shadow: 10px 1px 3px rgba(0, 0, 0, 0.05),
		10px 20px 40px rgba(92, 103, 153, 0.2);
}
.full-container-svg img {
	position: absolute;
	width: 100vw;
	background-size: cover;
	background-repeat: no-repeat;
	z-index: -1;
}

@media screen and (max-width: 770px) {
	.full-container-svg img {
		position: absolute;
		width: inherit;
		height: 100%;
		background-size: cover;
		background-repeat: no-repeat;
		z-index: -1;
		/* background-color: khaki; */
	}
}
</style>
